/**
 * SMS Template-specific translation keys
 */
export const smsTemplate = {
  list: {
    search_placeholder: "admin.sms_template_search_placeholder",
    main_heading: "admin.sms_template_list_heading",
    no_permission_to_view: "admin.sms_template_no_permission_to_view",
    table: {
      created_at_table_col_heading: "admin.sms_template_created_at_table_col_heading",
      title_table_col_heading: "admin.sms_template_title_table_col_heading",
      content_table_col_heading: "admin.sms_template_content_table_col_heading",
      action_table_col_heading: "admin.sms_template_action_table_col_heading",
    },
    create_sms_template_btn_text: "admin.sms_template_create_btn_text",
    delete_popup_heading_text: "admin.sms_template_delete_popup_heading_text",
    delete_popup_yes_btn_text: "admin.sms_template_delete_popup_yes_btn_text",
    delete_popup_no_btn_text: "admin.sms_template_delete_popup_no_btn_text",
    clear_filter_btn_text: "admin.sms_template_clear_filter_btn_text",
  },
  add: {
    main_heading: "admin.sms_template_add_heading",
    slug_label: "admin.sms_template_slug_label",
    slug_placeholder: "admin.sms_template_slug_placeholder",
    parameter_label: "admin.sms_template_parameter_label",
    parameter_label_placeholder: "admin.sms_template_parameter_placeholder",
    title_label: "admin.sms_template_title_label",
    title_placeholder: "admin.sms_template_title_placeholder",
    content_label: "admin.sms_template_content_label",
    content_placeholder: "admin.sms_template_content_placeholder",
    submit_btn_text: "admin.sms_template_submit_btn_text",
    cancel_btn_text: "admin.sms_template_cancel_btn_text",
    loading_btn_text: "admin.sms_template_loading_btn_text",
    update_btn_text: "admin.sms_template_update_btn_text",
  },
  edit: {
    main_heading: "admin.sms_template_edit_heading",
  },
  form: {
    slug_label: "admin.sms_template_slug_label",
    slug_placeholder: "admin.sms_template_slug_placeholder",
    parameter_label: "admin.sms_template_parameter_label",
    parameter_label_placeholder: "admin.sms_template_parameter_placeholder",
    title_label: "admin.sms_template_title_label",
    title_placeholder: "admin.sms_template_title_placeholder",
    content_label: "admin.sms_template_content_label",
    content_placeholder: "admin.sms_template_content_placeholder",
    submit_btn_text: "admin.sms_template_submit_btn_text",
    cancel_btn_text: "admin.sms_template_cancel_btn_text",
    loading_btn_text: "admin.sms_template_loading_btn_text",
    update_btn_text: "admin.sms_template_update_btn_text",
  },
};
